export enum variantsTheme {
  DARK = 'dark-theme',
  LIGHT = 'light-theme',
}
export const COLOR_SCHEME = 'color-scheme'
